
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magnets-tech-tests",
      function () {
        return require("private-next-pages/magnets-tech-tests.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magnets-tech-tests"])
      });
    }
  